$.fn.ShareToolbar = function(overlay) {
  let self = this

  if (self.data('share-toolbar')) {
    return self.data('share-toolbar')
  }

  self.close = function() {
    self.attr('aria-expanded', 'false')
    $('html').off('click', self.clicked_outside)
    overlay.el.scroller.scrollEvents.removeCallback(self.close)
    $('.overlay-toolbar__share-action--copied-link').removeClass('overlay-toolbar__share-action--copied-link')
  }

  self.open = function() {
    self.attr('aria-expanded', 'true')
    $('html').on('click', self.clicked_outside)
    overlay.el.scroller.scrollEvents.add(self.close)
  }

  self.clicked_outside = function(e) {
    if (!$(e.target).closest('.overlay-toolbar').length) {
      self.close()
    }
  }

  self.clicked = function(e) {
    e.stopPropagation()
    if (self.attr('aria-expanded') === 'true') {
      self.close()
    } else {
      self.open()
    }
  }

  self.initialize_copy = function() {
    $('.overlay-toolbar__share-action--copy-link').on('click', function() {
      let button = $(this)
      button.find('textarea').val(window.location.href).focus().select()
      document.execCommand("Copy")
      button.find('textarea').blur()
      button.addClass('overlay-toolbar__share-action--copied-link')
      setTimeout(function() {
        button.removeClass('overlay-toolbar__share-action--copied-link')
      }, 2800)
    })
  }

  return function() {
    self.BlockElement()
    self.find('.overlay-toolbar__share-btn').on('click', self.clicked)
    self.initialize_copy()
    self.data('share-toolbar', self)
    return self
  }()
}
